import { Component, OnInit } from '@angular/core';

import { DashboardService } from "../../../providers/dashboard.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthService } from "../../../providers/auth.service";
import { Modules } from "src/app/core/model/modules.enum";
import { MessageService } from "primeng/api";
import { environment } from "../../../../environments/environment";

import { ApexAxisChartSeries, ApexNonAxisChartSeries, ApexGrid, ApexChart, ApexXAxis, ApexYAxis, ApexMarkers, ApexStroke, ApexLegend, ApexResponsive, ApexTooltip, ApexFill, ApexDataLabels, ApexPlotOptions, ApexTitleSubtitle, ApexAnnotations } from 'ng-apexcharts';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from "ngx-ui-loader";

import * as moment from 'moment';
import { get, isEmpty, toArray, toInteger, map as lodashMap, uniq, sortBy, filter } from 'lodash';
import { Router } from '@angular/router';
import { dateTimePipe } from 'src/app/shared/pipe/datePipe';
import { CommonService } from 'src/app/providers/common.service';

export type apexChartOptions = {
  series: ApexAxisChartSeries;
  nonAxisSeries: ApexNonAxisChartSeries;
  colors: string[];
  grid: ApexGrid;
  chart: ApexChart;
  xaxis: ApexXAxis;
  yaxis: ApexYAxis;
  markers: ApexMarkers,
  stroke: ApexStroke,
  legend: ApexLegend,
  responsive: ApexResponsive[],
  tooltip: ApexTooltip,
  fill: ApexFill
  dataLabels: ApexDataLabels,
  plotOptions: ApexPlotOptions,
  labels: string[],
  title: ApexTitleSubtitle,
  annotations: ApexAnnotations
};

@Component({
  selector: 'merchantv2-dashboard',
  templateUrl: './dashboardv2-merchant.component.html',
  styleUrls: ['./dashboardv2.component.scss'],
  preserveWhitespaces: true
})
export class Dashboardv2MerchantComponent implements OnInit {
  public userPrivilege: any;
  /**
   * Apex chart
   */
  public apexChart1Options: Partial<apexChartOptions>;
  public apexChart2Options: Partial<apexChartOptions>;
  public apexChart3Options: Partial<apexChartOptions>;
  public apexChart4Options: Partial<apexChartOptions>;
  public apexChart5Options: Partial<apexChartOptions>;
  public apexChart6Options: Partial<apexChartOptions>;
  public apexChart7Options: Partial<apexChartOptions>;
  public apexChart8Options: Partial<apexChartOptions>;
  public apexChart9Options: Partial<apexChartOptions>;
  public apexChartCBOptions: Partial<apexChartOptions>;

  public modalWidget1: string = "";
  public modalWidget2: string = "";
  public modalWidget3: string = "";
  public modalWidget4: string = "";
  public modalWidget5: string = "";
  public modalWidget6: string = "";
  public modalWidget7: string = "";
  public modalWidget8: string = "";
  public modalWidget9: string = "";

  public tpns: any;

  // Todays
  public todayTransactionsVolume: any;
  public todayTransactionsCount: any;

  // Transactions Count
  public last3MonthTransactionsCount: any;
  public lastMonthTransactionsCount: any;
  public currentMonthTransactionsCount: any;

  // Transactions Volume
  public last3MonthTransactionsVolume: any;
  public lastMonthTransactionsVolume: any;
  public currentMonthTransactionsVolume: any;

  public last3MonthCount: any = 0;
  public lastMonthCount: any = 0;
  public currentMonthCount: any = 0;
  public todayVolume: any = 0;

  // Transactions Volume
  public last3MonthVolume: any = 0;
  public lastMonthVolume: any = 0;
  public currentMonthVolume: any = 0;
  public todayCount: any = 0;

  // Third Row
  public averageTicketSize: any;
  public txRatio: any;

  public fDt: any;
  public ownerMerchantId: any;
  public storeData: any;

  public averageClosedBatch: any;
  public tpnIdArray: any;
  public storeIdArray: any;
  public selectedStoreId: any;
  public tpnLabelData: any;
  public selectedTPN: any;

  public selStore: any;
  public selTPN: any;
  public selRange: any;
  public rangeIdArray: any;
  public selectedRangeValue: any;
  public overallAverageClosedBatch: any;
  public overallClosedBatchTotal: any;
  public averageClosedBatchTicketSize: any;
  public CBChartShow: boolean;
  public selectedRangeTitle: any;
  public transactionAvgTicketSize: any;

  public thisMonthTransactionTitle: string;
  public lastMonthTransactionTitle: string;
  public totalTransactionTitle: string;
  public todayTransactionTitle: String;

  public overallCBBaseAmount: any;
  public overallCBTipAmount: any;
  public overallCBTaxAmount: any;
  public overallCBFeeAmount: any;
  public applyRangeValue: any;
  public storeLen: any;
  public isLoading:boolean;
  public isStateShow:boolean = false;
  public isChartShow:any = true;
  public isMobileView: any;
  public isflag : boolean= false;
  TimePeriodtoday:any = "Today"
  TimePeriodThismonth:any = "This Month"
  TimePeriodLastmoth:any = "Last Month"
  TimePeriodOverall:any = "Overall"


  public chartColors = [
    '#9c1aff99', //purple
    '#c2e68499', // green
    '#9c1aff4d', // purple
    '#c2e68499', // green
    '#00FFFF',  // Cyan 
    '#0000FF', // Blue
    '#800080', // Purple
    '#00008B', // Dark Blue
    '#FFFF00', // Yellow
    '#00FF00', // Lime
    '#FF00FF', // Magenta
    '#97A2D7', // Silver
    '#D798A3', // Pink
    '#FFD700', // Gold - yellow
    '#808080', // Grey
    '#000000', // Black
    '#FFA500', // Orange
    '#A52A2A', // Brown
    '#008000', // Green
    '#808000', // Olive
    '#800000', // Maroon
    '#7FFFD4', // Aquamarine
    '#FFE87C', // Sun Yellow
    '#806517', // Oak Brown
    '#ADD8E6' // Ligh Blue
  ]

  /**
   * NgbDatepicker
   */
  currentDate: NgbDateStruct;

  private dateFormat = "YYYY-MM-DD HH:mm:ss";
  //private localTZ = moment().format('Z');
  private localTZ = 'America/New_York';  // Default set to EDT|EST time-zone -04:00 offset
  private posResponseCode = "'00','10','11','85'";

  show = true;
  constructor(private DashboardService: DashboardService, public commonService: CommonService, private messageService: MessageService, private router: Router, private modalService: NgbModal, private auth: AuthService, private ngxService: NgxUiLoaderService,) {
    this.apexChart1Options = {
      series: [{ name: '', data: [0, 0, 0, 0] }],
      chart: {
        type: "bar",
        height: '100%',
        width: '30%',
        stacked: false,
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          distributed: true,
        }
      },
      dataLabels: {
        enabled: false
      },
      grid: {
        show: true,
      },
      xaxis: {
        type: "category",
        categories: ["", "", ""],
        labels: {
          style: {
            fontSize: "12px"
          }
        },
      },
      legend: {
        show: false,
      },
      fill: {
        opacity: 1
      },
      yaxis: {
        show: false,
      }
    }
    this.apexChart2Options = this.apexChart1Options;
    this.apexChart3Options = this.apexChart1Options;
    this.apexChart4Options = this.apexChart1Options;
    this.apexChart5Options = this.apexChart1Options;
    this.apexChart6Options = this.apexChart1Options;
    this.apexChart7Options = this.apexChart1Options;
    this.apexChart8Options = this.apexChart1Options;
    this.apexChart9Options = this.apexChart1Options;
    this.apexChartCBOptions = this.apexChart1Options;

    // Todays
    this.todayTransactionsVolume = 0;
    this.todayTransactionsCount = 0;

    // Transactions Count
    this.last3MonthTransactionsCount = 0;
    this.lastMonthTransactionsCount = 0;
    this.currentMonthTransactionsCount = 0;
    // Transactions Volume
    this.last3MonthTransactionsVolume = 0;
    this.lastMonthTransactionsVolume = 0;
    this.currentMonthTransactionsVolume = 0;

    this.fDt = 0;
    this.ownerMerchantId = '';

    this.averageTicketSize = 0;
    this.txRatio = '0% | 0% | 0%';

    this.averageClosedBatch = 0;
    this.tpnIdArray = [];
    this.storeIdArray = [];
    this.storeData = [];
    this.tpnLabelData = [];
    this.selectedStoreId = '';
    this.selectedTPN = '';
    this.rangeIdArray = [];
    this.selectedRangeValue = 30;
    this.selRange = 30;
    this.overallAverageClosedBatch = 0;
    this.overallClosedBatchTotal = 0;
    this.averageClosedBatchTicketSize = 0;
    this.CBChartShow = true;
    this.selectedRangeTitle = '';
    this.transactionAvgTicketSize = 0;

    this.overallCBBaseAmount = 0;
    this.overallCBTipAmount = 0;
    this.overallCBTaxAmount = 0;
    this.overallCBFeeAmount = 0;
    this.applyRangeValue = 30;
    this.storeLen = 0;
  
    this.thisMonthTransactionTitle = 'Processing Volume - This Month';
    this.lastMonthTransactionTitle = 'Processing Volume - Last Month';
    this.totalTransactionTitle = 'Processing Volume - 12 Months';
    this.todayTransactionTitle = 'Processing Volume - Today';
    
  }
  isShowLabel:boolean = true;
  isFilter:boolean = true;
  async ngOnInit(): Promise<any> {
    this.isMobileView = this.commonService.isMobileView;

   if(this.auth.getUserType() == 'STORE_MANAGER') { 
    this.ownerMerchantId = ''; 
    this.isflag = true;
  }
    if(this.auth.getUser.userType =="STORE_MANAGER"){ 
      this.isFilter = false;   
     
       if (this.auth.getUser.defaultUser == false) {
      
        this.selectedStoreId = this.auth.getUser.addOnStoreOwnerId
        this.tpns = await this.getAllTransactions([this.selectedStoreId]); // [merchantId]
      } else {
        this.selectedStoreId = this.auth.getUser.storeId;
        this.tpns = await this.getAllTransactions([this.selectedStoreId]); // [merchantId]
      }
    }
    if(this.auth.getUser.userType =="MERCHANT"){
      if (this.auth.getUser.defaultUser == false) {
        this.ownerMerchantId = await this.getOwnerMerchantId();
        this.tpns = await this.getAllTransactions([this.ownerMerchantId]); // [merchantId]
      } else {
        this.ownerMerchantId = await this.getMerchantId();
        this.tpns = await this.getAllTransactions([this.getMerchantId()]); // [merchantId]
      }
    }


    this.storeData = await this.getStoreId();
    this.storeIdArray = this.storeData.dropDownValues.sort((a,b) => a.dba.localeCompare(b.dba));

    // let tpnNo = this.tpns;
    this.tpnLabelData = await this.getTPNandLabel();
    this.tpnIdArray = this.tpnLabelData.dropDownValues;

    //Date Range Filter 
    this.rangeIdArray = [{'range': 30, 'rangeLabel':'Last 30 days'}, {'range': 60, 'rangeLabel':'Last 60 days'}, {'range': 90, 'rangeLabel':'Last 90 days'}, {'range': 'currentMonth', 'rangeLabel':'Current Month'}, {'range': 'yesterday', 'rangeLabel':'Yesterday'}, {'range': 'lastMonth', 'rangeLabel':'Last Month'}];
    //this.rangeIdArray = [{'range': 30, 'rangeLabel':'Last 30 days'}, {'range': 60, 'rangeLabel':'Last 60 days'}, {'range': 90, 'rangeLabel':'Last 90 days'}, {'range': 'currentMonth', 'rangeLabel':'Current Month'}, {'range': 'lastMonth', 'rangeLabel':'Last Month'}, {'range': 'yesterday', 'rangeLabel':'Yesterday'}];    
    
    await this.sleeper(500);
    this.tpns = this.tpns.map(item => "'" + item + "'").toString();
    // Init Process Done
  
      this.startAllTransaction();
  }

  async getStoreId() {
    try {
      const getStoreId = await this.DashboardService.getStoreId().pipe().toPromise();
      return getStoreId;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }

  async getTPNandLabel() {
    try {
      const getStoreId = await this.DashboardService.getTPNandLabel().pipe().toPromise();
      return getStoreId;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }  

  getSelectedRange(selectedRange) {
    this.selectedRangeValue = selectedRange.range;
    this.getClosedBatch();
  }
  callselectStore(){
    this.getLast33MonthTransactionsVolume();
    this.getLast3MonthTransactionsVolume();
  }

  getSelectedStore(selectedStore) {
    if (isEmpty(selectedStore)) {      
      this.clear();      
    } else {
      if (selectedStore.length > 5) {
        alert('Please select upto 5 stores to compare sales...');
        return;
      }
      this.selTPN = null;
    
      this.selectedStoreId = selectedStore.map(item => "'"+ item.id +"'").toString();
      this.selectedTPN = '';
      this.storeLen = selectedStore.length;
      this.callselectStore();
      this.getClosedBatch();
    }
  }

  clear() {
    if(this.auth.getUser.userType =="MERCHANT"){
      this.selectedStoreId = '';
    }
    this.selectedTPN = '';
    this.apexChartCBOptions = this.apexChart1Options;
    this.callselectStore();
    this.getClosedBatch();
  }

  getSelectedTPN(selectedTPNData) {
    if (isEmpty(selectedTPNData)) {      
      this.clear();      
    } else {
      this.selStore = null;
      if(this.auth.getUser.userType =="MERCHANT"){
      this.selectedStoreId = '';
    }
      this.selectedTPN = selectedTPNData.tpn;
      this.callselectStore();
      this.getClosedBatch();
    }
  }

  refreshComponent() {
    this.startAllTransaction();
  }

  startAllTransaction() {

    // Closed Batch
    this.getClosedBatch();

    this.getLast3MonthTransactionsVolume();
    this.getLast33MonthTransactionsVolume();
    
  }

  sleeper = (delay) => new Promise((resolve) => setTimeout(resolve, delay));

  async getAllTransactions(bodyData: string[]) {
    try {
      const getAllTransactions = await this.DashboardService.getAllTransactions(bodyData).pipe().toPromise();
      return getAllTransactions.data;
    } catch (err) {
      // this.showAlert(err, "error");
      return [];
    }
  }

  isPermission(privilege) {
    return this.userPrivilege.indexOf(privilege) != -1;
  }

  getUserType() {
    return this.auth.getUser.userType;
  }

  getMerchantId() {
    return this.auth.getUser.merchantId;
  }

  getPrivileges() {
    return this.auth.getPrivileges(Modules.USER).features;
  }

  async getOwnerMerchantId() {
    try {
      const getOwnerMerchantId = await this.DashboardService.getOwnerMerchantId().pipe().toPromise();
      return getOwnerMerchantId.data;
    } catch (err) {
      return [];
    }
  }


  getMonth = (month = 0, year = null,) => {
    const months = ["", "Jan", "Feb", "Mar", "April", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    if (year) {
      try {
        return `${months[month]} - ${year.toString().replace("20", "")}`;
      } catch (e) {
        console.log("replace error", e);
        return `${months[month]}`;
      }
    } else {
      return `${months[month]}`;
    }
  }

  currency(labelValue) {
    // Nine Zeroes for Billions
    let currency: any = "";
    currency = (Math.abs(Number(labelValue)) >= 1.0e+9)
      ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(2) + "B"
      // Six Zeroes for Millions 
      : (Math.abs(Number(labelValue)) >= 1.0e+6)
        ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(2) + "M"
        // Three Zeroes for Thousands
        : (Math.abs(Number(labelValue)) >= 1.0e+3)
          ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(2) + "K"
          : Math.abs(Number(labelValue));

    return `$ ${currency}`;
  }

  numbering(labelValue) {
    // Nine Zeroes for Billions
    let currency: any = "";
    currency = (Math.abs(Number(labelValue)) >= 1.0e+9)
      ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(0) + "B"
      // Six Zeroes for Millions 
      : (Math.abs(Number(labelValue)) >= 1.0e+6)
        ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(0) + "M"
        // Three Zeroes for Thousands
        : (Math.abs(Number(labelValue)) >= 1.0e+3)
          ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(0) + "K"
          : Math.abs(Number(labelValue));

    return `${currency}`;
  }


  // Summary
  openModalWidget7(content,loaderId?:string,catagory?:string) {
    this.isLoading =true;
    this.ngxService.startBackgroundLoader(loaderId)
    let fromDate = moment().subtract(12, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = moment().endOf('month').format(this.dateFormat);
     this.payLoad = {
      qry: catagory =='transaction'? 'openModalWidget7' :'openModalWidget7Merchant', 
      localTZ: this.localTZ, 
      fromDate: fromDate,
      endOfMonth: endOfMonth,     
      ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN 
    };
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item) => {
          data.push(this.payLoad.qry == 'openModalWidget7Merchant'? item.totalVolume/100 :item.totalVolume);          categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
        });
        series = [
          {
            name: "Volume",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              '#9c1aff99',
              '#c2e68499',
              '#9c1aff4d',
              '#c2e68499'
              // "#008FFB",
              // "#00E396",
              // "#FEB019",
              // "#FF4560",
              // "#775DD0",
              // "#546E7A",
              // "#26a69a",
              // "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                }
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (data, opts) {
                return thisClass.currency(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return '$' + data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget7 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.ngxService.stopBackgroundLoader(loaderId)
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  last3MonthsTransaction(loaderId?:string,catagory?:string){
    this.openModalWidget7(null,loaderId,catagory);
  }

  // Summary
  openWidget70(loaderId?:string,catagory?:string) {
    this.openModalWidget7(null,loaderId,catagory);
  }

  // Device Type
  openWidget71(catagory?:string) {
    this.ngxService.startBackgroundLoader('loader-0707');
    let fromDate = moment().subtract(12, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = moment().endOf('month').format(this.dateFormat);
      this.payLoad = {
        qry: catagory =='transaction'?'openWidget71': 'openWidget71Merchant', 
        localTZ: this.localTZ, 
        fromDate: fromDate,
        endOfMonth: endOfMonth,          
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN
     };
    // *** removed tpns // tpns: this.tpns? this.tpns : '',
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perYear','perMonth']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((deviceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                deviceType,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
                templateData[i].totalVolume = this.payLoad.qry === 'openWidget71Merchant'
                ? rawData[j].totalVolume / 100
                : rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);

        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "40%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader('loader-0707');
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Card Type

  // Channel
  openWidget73(catagory?:string) {
    this.ngxService.startBackgroundLoader('loader-0707');
    let fromDate = moment().subtract(12, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = moment().endOf('month').format(this.dateFormat);
   
      this.payLoad = {
        qry: catagory =='transaction'? 'openWidget73' : 'openWidget73Merchant', 
        localTZ: this.localTZ, 
        fromDate: fromDate,
        endOfMonth: endOfMonth,
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '', 
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN 
     };   
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perMonth']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((sourceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                sourceType,
                perYear,
                perMonth,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
                templateData[i].totalVolume = this.payLoad.qry === 'openWidget73Merchant'
                ? rawData[j].totalVolume / 100
                : rawData[j].totalVolume;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);

        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

       
        if (series.length > 0) {
          this.apexChart7Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "40%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader('loader-0707');
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }


  // Summary
  openModalWidget8(content,loaderId?:string,catagory?:string) {
    this.isLoading = true;
    this.ngxService.startBackgroundLoader(loaderId)
    let fromDate = moment().subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = moment(fromDate).endOf('month').format(this.dateFormat);
      this.payLoad = {
        qry: catagory =='transaction'? 'openModalWidget8':'openModalWidget8Merchant', 
        localTZ: this.localTZ, 
        fromDate: fromDate,
        endOfMonth: endOfMonth,   
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN 
      };
     // *** removed tpns // tpns: this.tpns? this.tpns : '',
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item, index) => {
          data.push(this.payLoad.qry == 'openModalWidget8Merchant' ?  item.totalVolume/100 : item.totalVolume);
          categories.push(`Week ${index + 1}`);
        });
        series = [
          {
            name: "Volume",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              '#9c1aff99',
              '#c2e68499',
              '#9c1aff4d',
              '#c2e68499'
              // "#008FFB",
              // "#00E396",
              // "#FEB019",
              // "#FF4560",
              // "#775DD0",
              // "#546E7A",
              // "#26a69a",
              // "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "50%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                }
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (data, opts) {
                return thisClass.currency(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return '$' + data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget8 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.ngxService.stopBackgroundLoader(loaderId)
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget80(loaderId?:string,catagory?:string) {
    this.openModalWidget8(null,loaderId,catagory);
  }

  // Device Type
  openWidget81(catagory?:string) {
    this.ngxService.startBackgroundLoader('loader-0808');
    let fromDate = moment().subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = moment(fromDate).endOf('month').format(this.dateFormat);
   
      this.payLoad = {
        qry: catagory =='transaction'? 'openWidget81' :'openWidget81Merchant', 
        localTZ: this.localTZ, 
        fromDate: fromDate,
        endOfMonth: endOfMonth,         
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN  
      };

    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
                templateData[i].totalVolume = this.payLoad.qry === 'openWidget81Merchant'
                ? rawData[j].totalVolume / 100
                : rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };

        }
        this.ngxService.stopBackgroundLoader('loader-0808');
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }


  // Channel
  openWidget83(catagory?:string) {
    this.ngxService.startBackgroundLoader('loader-0808');
    let fromDate = moment().subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = moment(fromDate).endOf('month').format(this.dateFormat);
    // if(catagory =='transaction'){
      this.payLoad = {
        qry: catagory =='transaction'? 'openWidget83': 'openWidget83Merchant', 
        localTZ: this.localTZ, 
        fromDate: fromDate,
        endOfMonth: endOfMonth,        
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN
      };

    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perWeek,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
                templateData[i].totalVolume = this.payLoad.qry === 'openWidget83Merchant'
                ? rawData[j].totalVolume / 100
                : rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart8Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader('loader-0808');
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  payLoad:any;
  apiCall:any;
  // Summary
  openModalWidget9(content,loaderId?:string,catagory?:string) {
    this.ngxService.startBackgroundLoader(loaderId);
    this.isLoading = true;
    let fromDate = moment().startOf('month').format(this.dateFormat);
    let endOfMonth = moment(fromDate).endOf('month').format(this.dateFormat);
      this.payLoad = {
        qry: catagory =='transaction'? 'openModalWidget9':'openModalWidget9Merchant', 
        localTZ: this.localTZ, 
        fromDate: fromDate,
        endOfMonth: endOfMonth,
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',        
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN 
      };
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData:any) => {
        let res = get(resData, 'data', []);
        let rawData = res;
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item, index) => {
          data.push(this.payLoad.qry == 'openModalWidget9Merchant'? item.totalVolume/100 :item.totalVolume);
          categories.push(`${item.perDay}`);
        });
        series = [
          {
            name: "Volume",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart9Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              '#9c1aff99',
              '#c2e68499',
              '#9c1aff4d',
              '#c2e68499'
              // "#008FFB",
              // "#00E396",
              // "#FEB019",
              // "#FF4560",
              // "#775DD0",
              // "#546E7A",
              // "#26a69a",
              // "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (data, opts) {
                return thisClass.currency(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              //offsetY: -20,
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return '$' + data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget9 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
       
        this.ngxService.stopBackgroundLoader(loaderId)
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  // Summary
  openWidget90(loaderId?:string,catagory?:string) {
    this.openModalWidget9(null,loaderId,catagory)
  }

  // Device Type
  openWidget91(catagory?:string) {
    this.ngxService.startBackgroundLoader('loader-0909');
    let fromDate = moment().startOf('month').format(this.dateFormat);
    let endOfMonth = moment(fromDate).endOf('month').format(this.dateFormat);
  
      this.payLoad = {
        qry: catagory =='transaction'? 'openWidget91':'openWidget91Merchant',
        localTZ: this.localTZ,      
        fromDate: fromDate,
        endOfMonth: endOfMonth,         
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN
     };
     // *** removed tpns // tpns: this.tpns? this.tpns : '',
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
                templateData[i].totalVolume = this.payLoad.qry === 'openWidget91Merchant'
                ? rawData[j].totalVolume / 100
                : rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart9Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };
        }
        this.ngxService.stopBackgroundLoader('loader-0909');
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }


  // Channel
  openWidget93(catagory?:string) {
    this.ngxService.startBackgroundLoader('loader-0909');
    let fromDate = moment().startOf('month').format(this.dateFormat);
    let endOfMonth = moment(fromDate).endOf('month').format(this.dateFormat);
      this.payLoad = {
        qry: catagory =='transaction'?'openWidget93':'openWidget93Merchant',
        localTZ: this.localTZ,
        fromDate: fromDate,
        endOfMonth: endOfMonth,
        ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
        selectedStoreId:this.selectedStoreId,
        selectedTPN:this.selectedTPN
     };
     // *** removed tpns // tpns: this.tpns? this.tpns : '',
    const thisClass = this;
    this.DashboardService.getNewMerchantDashboardData(this.payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'batchSourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((batchSourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                batchSourceType,
                perMonth,
                perDay,
                totalVolume: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].batchSourceType == templateData[i].batchSourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
                templateData[i].totalVolume = this.payLoad.qry === 'openWidget93Merchant'
                ? rawData[j].totalVolume / 100
                : rawData[j].totalVolume;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { batchSourceType: item });
          gropingData = lodashMap(gropingData, 'totalVolume');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart9Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.currency(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            fill: {
              opacity: 1
            }
          };
        }
        this.ngxService.stopBackgroundLoader('loader-0909');
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  numberWithCommas(number) {
    return number.toString();
  }

  numberWithCommasUS(givenNumber) {
    let nfObject = new Intl.NumberFormat('en-US');
    return nfObject.format(givenNumber);
  }

  amountWithCommas(amount) {
    return '$ ' + amount.toString();
  }


  // Transactions Volume
  getLast3MonthTransactionsVolume() {
    // let fromDate = moment().subtract(3, 'M').startOf('month').format(this.dateFormat);
    // let endOfMonth = moment().endOf('day').format(this.dateFormat);
    
    this.ngxService.startBackgroundLoader("loader-09");

    this.ngxService.startBackgroundLoader("loader-14");    
    this.ngxService.startBackgroundLoader("loader-08");    
    this.ngxService.startBackgroundLoader("loader-07");    

    // Last 3 month
    let fromDateL3M = moment().subtract(3, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthL3M = moment().endOf('day').format(this.dateFormat);
    // Last month
    let fromDateLM = moment().subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = moment(fromDateLM).endOf('month').format(this.dateFormat);
    // Current month
    let fromDateCM = moment().startOf('month').format(this.dateFormat);
    let endOfMonthCM = moment(fromDateCM).endOf('month').format(this.dateFormat);
    // today
    let fromDate = moment().startOf("day").format(this.dateFormat);
    let endOfMonth = moment().endOf("day").format(this.dateFormat);
    // Last 30 days
    let fromDateL30D = moment().subtract(30, 'd').startOf('day').format(this.dateFormat);
    let endOfMonthL30D = moment().endOf('day').format(this.dateFormat);

    let localTZ = moment().format('Z');
    const payLoad = {
      qry: 'getLast3MonthTransactionsVolumeMerchant',
      timeZone: localTZ,
      fromDateL3M: fromDateL3M,
      endOfMonthL3M: endOfMonthL3M,
      fromDate: fromDate,
      endOfMonth: endOfMonth,
      fromDateCM: fromDateCM,
      endOfMonthCM: endOfMonthCM,
      fromDateLM: fromDateLM,
      endOfMonthLM: endOfMonthLM,
      fromDateL30D: fromDateL30D,
      endOfMonthL30D: endOfMonthL30D,
      selectedStoreId: this.selectedStoreId,
      ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '', 
      selectedTPN: this.selectedTPN
     };
     //*** removed tpn // tpns: this.tpns? this.tpns : ''
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let responseData = get(res, 'data', []);
        responseData.forEach((item, index) => {
          // if (item.totalCount < 99000) {
          //   this.last3MonthTransactionsVolume = this.amountWithCommas(item.last3Month);
          //   this.lastMonthTransactionsVolume = this.amountWithCommas(item.lastMonth);
          //   this.currentMonthTransactionsVolume = this.amountWithCommas(item.currentMonth);
          //   this.todayTransactionsVolume = this.amountWithCommas(item.today);
            
          // } else {
          //   this.last3MonthTransactionsVolume = this.currency(item.last3Month);
          //   this.lastMonthTransactionsVolume = this.currency(item.lastMonth);
          //   this.currentMonthTransactionsVolume = this.currency(item.currentMonth);
          //   this.todayTransactionsVolume = this.currency(item.today);
          // }
          this.last3MonthTransactionsVolume = ((item.last3Month < 99000)? this.amountWithCommas(item.last3Month/100) : this.currency(item.last3Month/100));
          this.lastMonthTransactionsVolume = ((item.lastMonth < 99000)? this.amountWithCommas(item.lastMonth/100) : this.currency(item.lastMonth/100));
          this.currentMonthTransactionsVolume = ((item.currentMonth < 99000)?  this.amountWithCommas(item.currentMonth/100) : this.currency(item.currentMonth/100));
          this.todayTransactionsVolume = ((item.today < 99000)?  this.amountWithCommas(item.today/100) : this.currency(item.today/100));          

          this.last3MonthTransactionsCount = ((item.last3MonthCount < 100000)? this.numberWithCommas(item.last3MonthCount) : this.numbering(item.last3MonthCount));
          this.lastMonthTransactionsCount = ((item.lastMonthCount < 100000)? this.numberWithCommas(item.lastMonthCount) : this.numbering(item.lastMonthCount));
          this.currentMonthTransactionsCount = ((item.currentMonthCount < 100000)?  this.numberWithCommas(item.currentMonthCount) : this.numbering(item.currentMonthCount));
          this.todayTransactionsCount = ((item.todayCount < 100000)?  this.numberWithCommas(item.todayCount) : this.numbering(item.todayCount));          

          this.averageTicketSize = this.currency(((item.last30Days/100) / item.last30DaysCount).toFixed(2));

        });
        this.ngxService.stopBackgroundLoader("loader-09");

        this.ngxService.stopBackgroundLoader("loader-14");
        this.ngxService.stopBackgroundLoader("loader-08");
        this.ngxService.stopBackgroundLoader("loader-07");

      },
      (err) => {
         this.showAlert(err, "error");
      }
    );
  }
  public onMerchantSelected: boolean = true;
  public merchantIds: any;
  public argStoreIds: any;
  getLast33MonthTransactionsVolume() {
    this.ngxService.startBackgroundLoader("loader-10");

    this.ngxService.startBackgroundLoader("loader-11");    
    this.ngxService.startBackgroundLoader("loader-12");    
    this.ngxService.startBackgroundLoader("loader-13"); 
    // Last 3 month
    let nowUTCL3M = moment().utc();
    let endOfMonthL3M = nowUTCL3M.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDateL3M = nowUTCL3M.tz(this.localTZ).subtract(3, 'M').startOf('month').format(this.dateFormat);
    // last month
    let nowUTCLM = moment().utc();
    let fromDateLM = nowUTCLM.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonthLM = nowUTCLM.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // current month
    let nowUTCCM = moment().utc();
    let fromDateCM = nowUTCCM.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonthCM = nowUTCCM.tz(this.localTZ).endOf('month').format(this.dateFormat);
    // today 
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf("day").format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf("day").format(this.dateFormat);
  //  this.merchantIds = this.ownerMerchantId;
    if(this.onMerchantSelected == false) { this.merchantIds = ''; }
   // if(this.auth.getUserType() != 'STORE_MANAGER') { this.argStoreIds = ''; }


    const payLoad = {
      qry: 'getLast3MonthTransactionsVolume', 
      localTZ: this.localTZ, 
      fromDate, 
      endOfMonth, 
      fromDateL3M, 
      endOfMonthL3M, 
      fromDateCM, 
      endOfMonthCM, 
      fromDateLM, 
      endOfMonthLM, 
      selectedStoreId: this.selectedStoreId,
      ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '', 
      selectedTPN: this.selectedTPN, 
      flag: this.isflag 
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let responseData = get(res, 'data', []);
        responseData.forEach((item, index) => {
          this.last3MonthVolume = this.currency(item.last3Month);
          this.lastMonthVolume = this.currency(item.lastMonth);
          this.currentMonthVolume = this.currency(item.currentMonth);
          this.todayVolume = this.currency(item.today);

          this.last3MonthCount = this.numbering(item.last3MonthCount);
          this.lastMonthCount = this.numbering(item.lastMonthCount);
          this.currentMonthCount = this.numbering(item.currentMonthCount);
          this.todayCount = this.numbering(item.todayCount);
        });
        this.ngxService.stopBackgroundLoader("loader-10");

        this.ngxService.stopBackgroundLoader("loader-11");
        this.ngxService.stopBackgroundLoader("loader-12");
        this.ngxService.stopBackgroundLoader("loader-13");
        
      },
      (err) => {
        // this.showAlert(err, "error in trans volume qry");
      }
    );
  }

  sumArray(array) {
    let sum = 0; 
  
    /*loop over array and add each item to sum
    */
    for (const item of array) {
      sum += item;
    }
   
   // return the result 
    return sum;
  }

  getCBAvgTicketSize(dtRange, dtEndRange) {
    let qryWhereStoreId = '';
    if (this.selectedStoreId != '') {
      qryWhereStoreId = ` AND storeId IN (${this.selectedStoreId}) `;
    }

    let qryWhereTPNNo = '';
    if (this.selectedTPN != '') {
      qryWhereTPNNo = ` AND tpn IN ('${this.selectedTPN}') `;
    }

    const payLoad = {
      qry: 'getCBAvgTicketSizeMerchant',
      selectedStoreId: this.selectedStoreId,
      selectedTPN: this.selectedTPN,
      dtRange: dtRange,
      dtEndRange: dtEndRange,
      ownerMerchantId: this.ownerMerchantId,
     };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        this.transactionAvgTicketSize = (res[0].batchTotalSum > 0) ? '$'+ ((res[0].batchTotalSum/100)/res[0].transactionCount).toFixed(2) : 0;
      });

  }

  getCloseBatchChartSeries(daysBefore, map: Map<string, any>) {
    const keys = map.keys();
    const series = []

    let daysBeforeLoopCount = (this.selectedRangeValue == 'lastMonth') ? (daysBefore - moment().utc().tz('America/New_York').date()) : daysBefore;

    for (const key of keys) {
      const startDate = moment().tz('America/New_York').subtract(daysBefore, 'days')
      const dates = new Array(daysBefore)
      const batchTotal = Array.from({ length: daysBefore }, () => 0)

      for (let i = 0; i < daysBeforeLoopCount; i++) {
        let firstDate = startDate
        dates[i] = firstDate.add(1, 'day').format('YYYY-MM-DD')
      }

      const currentSeries = map.get(key);
      const batches = currentSeries.map(each => {
        let index = dates.indexOf(each.DT)
        batchTotal[index] = each.batchTotal/100
      })

      const dataSeries = []
      for (let i = 0; i < daysBeforeLoopCount; i++) {
        dataSeries.push([
          dates[i],
          batchTotal[i]
        ])
      }

      const eachSeriesObj = {
        name: key,
        data: dataSeries
      }

      series.push(eachSeriesObj)
    }

    return series;

  }

  getClosedBatch() {
    const thisClass = this;
    this.ngxService.startBackgroundLoader("loader-15");
    // let fromDate = moment().startOf("day").format(this.dateFormat);
    // let endOfMonth = moment().endOf("day").format(this.dateFormat);    
    // let localTZ = moment().format('Z');


    let qryWhereStoreId = '';
    if (this.selectedStoreId != '') {
      qryWhereStoreId = ` AND storeId IN (${this.selectedStoreId}) `;
    }

    let qryWhereTPNNo = '';
    if (this.selectedTPN != '') {
      qryWhereTPNNo = ` AND tpn IN ('${this.selectedTPN}') `;
    }

    let noDays = 30;
    let noDaysLastMonth = moment().utc().tz('America/New_York').subtract(1, 'M').daysInMonth();
    let dtRange = '';
    let dtEndRange = '';
    this.selectedRangeTitle = 'Last 30 days';

    switch(this.selectedRangeValue) {

      case 'currentMonth':
        noDays = moment().utc().tz('America/New_York').date();
        dtRange = 'P'+(noDays-1)+'D';
        this.selectedRangeTitle = 'Current Month';
        this.applyRangeValue = noDays;
        break;

      case 'lastMonth':
        //let noDaysLastMonth = moment().utc().tz('America/New_York').subtract(1, 'M').daysInMonth();
        noDays = noDaysLastMonth + moment().utc().tz('America/New_York').date();
        dtRange = 'P'+(noDays-1)+'D';        
        this.selectedRangeTitle = 'Last Month';
        this.applyRangeValue = noDays;
        dtEndRange = ` AND TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', 'America/New_York') <= TIME_FORMAT(TIME_SHIFT(CURRENT_TIMESTAMP, '${'P'+moment().utc().date()+'D'}', -1, 'America/New_York'), 'yyyy-MM-dd 23:59:59') `;
        break;
  
      case 'yesterday':
        dtRange = 'P'+1+'D';
        this.selectedRangeTitle = 'Yesterday';
        this.applyRangeValue = 1;
        dtEndRange = ` AND TIME_FORMAT(__time, 'yyyy-MM-dd HH:mm:ss', 'America/New_York') <= TIME_FORMAT(TIME_SHIFT(CURRENT_TIMESTAMP, '${dtRange}', -1, 'America/New_York'), 'yyyy-MM-dd 23:59:59') `;
        break;

      case 60: 
        dtRange = 'P60D';
        this.selectedRangeTitle = 'Last 60 days';
        this.applyRangeValue = 60;
        break;

      case 90: 
        dtRange = 'P90D';
        this.selectedRangeTitle = 'Last 90 days';
        this.applyRangeValue = 90;
        break;
        
      case 30: 
        dtRange = 'P30D';
        this.selectedRangeTitle = 'Last 30 days';
        this.applyRangeValue = 30;
        break;

      default: 
        dtRange = 'P30D';
        this.selectedRangeTitle = 'Last 30 days';
        this.applyRangeValue = 30;
        break;        

    }

    const payLoad = {
      qry: 'getClosedBatchMerchant',
      ownerMerchantId: this.ownerMerchantId,
      dtRange: dtRange,
      dtEndRange: dtEndRange,
      selectedStoreId: this.selectedStoreId,
      selectedTPN: this.selectedTPN
     };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        if (res.length > 0) {

          /* commented below currency formats  */
          // this.overallAverageClosedBatch = thisClass.currency((res[0].batchTotalSum/this.applyRangeValue).toFixed(2));
          // this.overallClosedBatchTotal = thisClass.currency((res[0].batchTotalSum).toFixed(2));
          // //this.averageClosedBatchTicketSize = thisClass.currency((res[0].batchTotalAvg).toFixed(2));
          // this.averageClosedBatchTicketSize = (res[0].batchTotalSum > 0) ? '$'+thisClass.numbering((res[0].batchTotalSum/res[0].cnt).toFixed(2)) : 0;

          // this.overallCBBaseAmount = thisClass.currency((res[0].batchBaseAmount).toFixed(2));
          // this.overallCBTipAmount = thisClass.currency((res[0].batchTipAmount).toFixed(2));
          // this.overallCBTaxAmount = thisClass.currency((res[0].batchTaxAmount).toFixed(2));
          // this.overallCBFeeAmount = thisClass.currency((res[0].batchFeeAmount).toFixed(2));
          this.overallAverageClosedBatch = '$'+((res[0].batchTotalSum/100)/this.applyRangeValue).toFixed(2);
          this.overallClosedBatchTotal = '$'+(res[0].batchTotalSum/100);
          //this.averageClosedBatchTicketSize = thisClass.currency((res[0].batchTotalAvg).toFixed(2));
          this.averageClosedBatchTicketSize = (res[0].batchTotalSum > 0) ? '$'+ ((res[0].batchTotalSum/100)/res[0].cnt).toFixed(2) : 0;

          this.overallCBBaseAmount = '$'+(res[0].batchBaseAmount/100).toFixed(2);
          this.overallCBTipAmount = '$'+(res[0].batchTipAmount/100).toFixed(2);
          this.overallCBTaxAmount = '$'+(res[0].batchTaxAmount/100).toFixed(2);
          this.overallCBFeeAmount = '$'+(res[0].batchFeeAmount/100).toFixed(2);          
        }
      }, (err) => {
        //this.showAlert(err, "error");
      }
    );

    const payLoadInner = {
      qry: 'getClosedBatchInnerMerchant',
      ownerMerchantId: this.ownerMerchantId,
      dtRange: dtRange,
      dtEndRange: dtEndRange,
      selectedStoreId: this.selectedStoreId,
      selectedTPN: this.selectedTPN
     };
    this.DashboardService.getNewMerchantDashboardData(payLoadInner).subscribe(
      (resData) => {
        let res = get(resData, 'data', []);
        let rawData = res;
        let data = [];
        let seriesData = [];
        let categories = [];
        let chartTitle = this.selectedRangeTitle;
        let storeMapArray = [];
        let chartSeries = [];


        if (this.selectedStoreId != '' && this.storeLen > 1) {
            const storeMap = new Map();
            rawData.forEach(each => {
              if (storeMap.has(each.storeId)) {
                storeMap.get(each.storeId).push(each);            
              } else {
                storeMap.set(each.storeId, [each]);
              }
            })

            chartSeries = this.getCloseBatchChartSeries(this.applyRangeValue, storeMap);
        }

        rawData.forEach((item, index) => {
            categories.push(item.DT);
            //data.push([item.DT, item.batchTotal/100]);
            data.push(item.batchTotal/100);
        });
        /* below commented the currency format */
        //this.averageClosedBatch = thisClass.currency((this.sumArray(data)/this.applyRangeValue).toFixed(2));
        if (this.selectedRangeValue == 'lastMonth') {
          this.averageClosedBatch = '$'+(this.sumArray(data)/noDaysLastMonth).toFixed(2);
        } else {
          this.averageClosedBatch = '$'+(this.sumArray(data)/this.applyRangeValue).toFixed(2);
        }

        if (this.selectedStoreId == '' || this.storeLen <= 1) {
          chartSeries = [
            {
              name: '',
              data: data,
            }
          ];
        } 

        if (rawData.length > 0) {
          this.CBChartShow = true;
        } else {
          this.CBChartShow = false;
          chartTitle = 'No settled batch transaction found...';
        }

        this.apexChartCBOptions ={
          series: chartSeries,
          chart:{
            height:350,
            type:'line',
            zoom:{
              enabled:true
            },
            toolbar: {
              show: true,
              tools: {
                pan: false,
                download: false,
              },
              export: {
                csv: {
                  filename: 'MerchantSalesChart',
                  columnDelimiter: ',',
                  headerCategory: 'Date',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'MerchantSalesChart',
                },
                png: {
                  filename: 'MerchantSalesChart',
                }
              },              
            }
          },
          // annotations: {
          //   position: 'front',
          //   yaxis: [{
          //     y: Math.round(this.averageClosedBatchTicketSize.replace('$','')),
          //     //y2: 10000,
          //     strokeDashArray: 5,
          //     borderColor: 'Red',
          //     label: {
          //       text: 'Y-axis annotation on '+ this.averageClosedBatchTicketSize,
          //     }
          //   }],
          // },
          dataLabels:{
            enabled:false,
            formatter: function (val, opt) {
              //return thisClass.currency(val);
              return '$'+val;
            },
          },
          colors:["#9a17ff"],
          stroke:{
            width: [5,7,5,7],
            curve:'smooth',
            dashArray:[0,0,0,0]
          },
          title:{
            text:chartTitle,
            align:'left',
          },
          grid:{
            row:{
              colors:["#F3F3F3","transparent"],
              opacity:0.5
            }
          },
          markers: {
            size: 5,
            hover: {
              sizeOffset: 4
            }
          },
          xaxis:{
            tickPlacement: 'between',
            labels: {
              rotate: -45,
              //rotateAlways: true,
              trim: false,
              formatter(value, timestamp?, opts?) {
                  return moment(value).format('MMM-D');
              },
            },
            type: 'category',
            categories: categories,
          },
          tooltip: {
            y: {   
              formatter: function(value, { series, seriesIndex, dataPointIndex, w }) {
                return 'Sale Amount: $'+value;
              },
              title: {
                formatter: (seriesName) => seriesName.slice(seriesName.lastIndexOf('@@')+2),
              }
         
            }            
          },
          legend: {
            show: true,
            formatter(legendName, opts?) {
                return legendName.slice(legendName.lastIndexOf('@@')+2);
            },
          }
        }
        this.ngxService.stopBackgroundLoader("loader-15");
        this.getCBAvgTicketSize(dtRange, dtEndRange);
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }  

  showAlert(data, alertType) {
    this.messageService.add({
      severity: alertType,
      summary: data.status,
      detail: data.message,
    });
  }
  openWidget60(loaderId?:string){
    this.openModalWidget6(null,loaderId)
  }
  openWidget61(){
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0606");
    const thisClass = this;
    const payLoad = {
      qry: 'openWidget61', 
      localTZ: this.localTZ, 
      fromDate, 
      endOfMonth, 
      ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN 
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });
        if (series.length > 0) {
          this.apexChart6Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [

                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0606");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );

  }
  openWidget63() {
    
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0606");
    const thisClass = this;
    const payLoad = {
      qry: 'openWidget63',
      localTZ: this.localTZ,
      fromDate,
      endOfMonth,
      ownerMerchantId: this.ownerMerchantId ? this.ownerMerchantId : '',
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN 
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perDay']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perDay = lodashMap(rawData, 'perDay');
        perDay = uniq(perDay);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perDay.forEach((perDay, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perDay,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perDay == templateData[i].perDay) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perDay, (perDay, index) => {
          return `${perDay}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart6Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0606");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  openWidget53() {
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0505");
    const thisClass = this;
    const payLoad = {
      qry: 'openWidget53', 
      localTZ: this.localTZ, 
      fromDate, 
      endOfMonth, 
      ownerMerchantId: this.ownerMerchantId ? this.ownerMerchantId : '',
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN  
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((sourceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                sourceType,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0505");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  openModalWidget6(content,loaderId?:string) {

    this.isLoading =true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);
    const thisClass = this;
    const payLoad = {
      qry: 'openModalWidget6', 
      localTZ: this.localTZ, 
      fromDate, 
      endOfMonth,  
      ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '',
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData = sortBy(rawData,['perDay']);

        rawData.forEach((item) => {
          data.push(item.totalCount);
          categories.push(`${item.perDay}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart6Options = {
            series: series,
            chart: {
              type: "line",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              "#9c1aff99",
              "#81d77999",
              "#c2e68499",
              "#9c1aff4d",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,                
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (data, opts) {
                return thisClass.numbering(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              //offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget6 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
       
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
  }
  openWidget50(loaderId?:string) {
    this.openModalWidget5(null,loaderId);
  }
  openWidget51() {
  
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0505");
    const thisClass = this;
    const payLoad = {
      qry: 'openWidget51',
      localTZ: this.localTZ,
      fromDate,
      endOfMonth,
      ownerMerchantId: this.ownerMerchantId ? this.ownerMerchantId : '',
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN 
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        let perWeek = lodashMap(rawData, 'perWeek');
        perWeek = uniq(perWeek);

        gropingDataType.forEach((deviceType, index) => {
          perMonth.forEach((perMonth, index) => {
            perWeek.forEach((perWeek, index) => {
              templateData.push({
                deviceType,
                perMonth,
                perWeek,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perMonth == templateData[i].perMonth &&
              rawData[j].perWeek == templateData[i].perWeek) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        categories = lodashMap(perWeek, (item, index) => {
          return `Week ${index + 1}`;
        });
        categories = uniq(categories);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });


        if (series.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0505");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }

  openModalWidget5(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let fromDate = nowUTC.tz(this.localTZ).subtract(1, 'M').startOf('month').format(this.dateFormat);
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);

    const thisClass = this;
    const payLoad = {qry: 'openModalWidget5', localTZ: this.localTZ, fromDate, endOfMonth, ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '', selectedStoreId:this.selectedStoreId,
    selectedTPN:this.selectedTPN };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item, index) => {
          data.push(item.totalCount);
          categories.push(`Week ${index + 1}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart5Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              "#9c1aff99",
              // "#81d77999",
              // "#c2e68499",
              // "#9c1aff4d",
              // "#775DD0",
              // "#546E7A",
              // "#26a69a",
              // "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                },
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (data, opts) {
                return thisClass.numbering(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget5 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
  }
  openWidget40(loaderId?:string) {
    this.openModalWidget4(null,loaderId);
  }
  openWidget41() {
  
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0404");
    const thisClass = this;
    const payLoad = {
      qry: 'openWidget41', 
      localTZ: this.localTZ, 
      fromDate, 
      endOfMonth, 
      ownerMerchantId: this.ownerMerchantId ? this.ownerMerchantId : '', 
      selectedStoreId:this.selectedStoreId,
      selectedTPN:this.selectedTPN  };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perMonth']);

        gropingDataType = lodashMap(rawData, 'deviceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((deviceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                deviceType,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].deviceType == templateData[i].deviceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);

        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { deviceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0404");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  openWidget43() {
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader("loader-0404");
    const thisClass = this;
    const payLoad = {
      qry: 'openWidget43',
      localTZ: this.localTZ,
      fromDate,
      endOfMonth,
      ownerMerchantId: this.ownerMerchantId ? this.ownerMerchantId : '',
      selectedStoreId: this.selectedStoreId,
      selectedTPN: this.selectedTPN
    };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {
        let rawData = get(res, 'data', []);

        let series = [];
        let categories = [];
        let gropingDataType = [];
        let templateData = [];

        rawData = sortBy(rawData,['perMonth']);

        gropingDataType = lodashMap(rawData, 'sourceType');
        gropingDataType = uniq(gropingDataType);

        let perYear = lodashMap(rawData, 'perYear');
        perYear = uniq(perYear);

        let perMonth = lodashMap(rawData, 'perMonth');
        perMonth = uniq(perMonth);

        gropingDataType.forEach((sourceType, index) => {
          perYear.forEach((perYear, index) => {
            perMonth.forEach((perMonth, index) => {
              templateData.push({
                sourceType,
                perYear,
                perMonth,
                totalCount: 0
              });
            });
          });
        });

        for (var i in templateData) {
          for (var j in rawData) {
            if (rawData[j].sourceType == templateData[i].sourceType &&
              rawData[j].perYear == templateData[i].perYear &&
              rawData[j].perMonth == templateData[i].perMonth) {
              templateData[i].totalCount = rawData[j].totalCount;
            }
          }
        }

        this.DashboardService.sortByPerYearPermonth(templateData);
        templateData = this.getFilteredChartArray(templateData, 0);

        categories = lodashMap(templateData, (item, index) => {
          return `${thisClass.getMonth(item.perMonth, item.perYear)}`;
        });
        categories = uniq(categories);
        categories = this.getFilteredChartArray(categories, 1);

        gropingDataType.forEach((item, index) => {
          let gropingData = filter(templateData, { sourceType: item });
          gropingData = lodashMap(gropingData, 'totalCount');
          series.push({ name: item, data: gropingData });
        });

        if (series.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: true,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: true,
                // offsetX: 0,
                // offsetY: 0,
                tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true,
                },
              },
              zoom: {
                enabled: false
              }
            },
            // colors: [
            //   "#008FFB",
            //   "#00E396",
            //   "#FEB019",
            //   "#FF4560",
            //   "#775DD0",
            //   "#546E7A",
            //   "#26a69a",
            //   "#D10CE8"
            // ],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  legend: {
                    position: "bottom",
                    // offsetX: -10,
                    // offsetY: 0
                  }
                }
              }
            ],
            stroke: {
              width: 100,
              colors: ['#fff']
            },
            plotOptions: {
              bar: {
                borderRadius: 0,
                horizontal: false,
                columnWidth: "30%",
                // distributed: true,
              }
            },
            dataLabels: {
              enabled: false,
              enabledOnSeries: undefined,
              textAnchor: 'middle',
              distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              shared: true,
              intersect: false,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return thisClass.numbering(data.toString());
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: true,
              position: "top",
              offsetY: 0,
            },
            colors: thisClass.chartColors,
            fill: {
              opacity: 1
            }
          };
          this.ngxService.stopBackgroundLoader("loader-0404");
        }
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
  }
  openModalWidget4(content,loaderId?:string) {
    this.isLoading = true;
    let nowUTC = moment().utc();
    let endOfMonth = nowUTC.tz(this.localTZ).endOf('month').format(this.dateFormat);
    let fromDate = nowUTC.tz(this.localTZ).subtract(12, 'M').startOf('month').format(this.dateFormat);
    this.ngxService.startBackgroundLoader(loaderId);
    const thisClass = this;
    const payLoad = {qry: 'openModalWidget4', localTZ: this.localTZ, fromDate, endOfMonth,ownerMerchantId: this.ownerMerchantId? this.ownerMerchantId : '', selectedStoreId:this.selectedStoreId,
    selectedTPN:this.selectedTPN };
    this.DashboardService.getNewMerchantDashboardData(payLoad).subscribe(
      (res) => {

        let rawData = get(res, 'data', []);
        let data = [];
        let series = [];
        let categories = [];

        rawData.forEach((item) => {
          data.push(item.totalCount);
          categories.push(`${thisClass.getMonth(item.perMonth, item.perYear)}`);
        });
        series = [
          {
            name: "Count",
            data
          }
        ];
        if (data.length > 0) {
          this.apexChart4Options = {
            series: series,
            chart: {
              type: "bar",
              height: 'auto',
              width: '100%',
              stacked: false,
              events: {
                click: function (chart, w, e) {

                }
              },
              toolbar: {
                show: false,
              },
              zoom: {
                enabled: true
              }
            },
            colors: [
              "#81d77999",
              "#9c1aff99",
              "#c2e68499",
              "#9c1aff4d",
              "#D10CE8",
              "#775DD0",
              "#546E7A",
              "#26a69a",
              "#D10CE8"
            ],
            responsive: [
              {
                breakpoint: 10,
                options: {
                }
              }
            ],
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: "30%",
                distributed: true,
                dataLabels: {
                  position: 'top', // top, center, bottom
                }
              }
            },
            dataLabels: {
              enabled: true,
              enabledOnSeries: undefined,
              formatter: function (data, opts) {
                return thisClass.numbering(data.toString());
              },
              style: {
                fontSize: '12px',
                colors: ["#304758"]
              },
              textAnchor: 'middle',
              offsetY: -20,
              //distributed: true,
            },
            grid: {
              show: true,
            },
            tooltip: {
              enabled: true,
              style: {  
                fontSize: '12px'
              },
              y: {
                formatter: function (data, opts) {
                  return data.toLocaleString('en-US');
                }
              }
            },
            xaxis: {
              type: "category",
              categories: categories,
              labels: {
                style: {
                  // colors: [
                  //   "#008FFB",
                  //   "#00E396",
                  //   "#FEB019",
                  //   "#FF4560",
                  //   "#775DD0",
                  //   "#546E7A",
                  //   "#26a69a",
                  //   "#D10CE8"
                  // ],
                  fontSize: "12px"
                }
              },
            },
            legend: {
              show: false,
            },
            fill: {
              opacity: 1
            }
          };
          if (content) {
            this.modalService
              .open(content, { centered: true, size: "lg" })
              .result.then((result) => {
                this.modalWidget4 = "Modal closed" + result;
              })
              .catch((res) => { });
          }
        }
        this.isLoading = false;
      },
      (err) => {
        // this.showAlert(err, "error");
      }
    );
    this.ngxService.stopBackgroundLoader(loaderId);
  }

  navigateToTransaction(navigateParams, numberOfMerchants) {
    let merchantDBAId = this.auth.getUser.merchantId;
    if (this.auth.getUser.defaultUser == false) {
      merchantDBAId = this.ownerMerchantId;
    }
    numberOfMerchants = numberOfMerchants.replace(/[^\d.-]/g, '');
    if(numberOfMerchants > 0) {

      let fromDate = '';
      let toDate = '';
      if(navigateParams["date"]=='today') {
        fromDate = moment().startOf("day").format(this.dateFormat);
        toDate = moment().endOf("day").format(this.dateFormat);
      } else if(navigateParams["date"]=='current') {
        fromDate = moment().startOf('month').format(this.dateFormat);
        toDate = moment(fromDate).endOf('month').format(this.dateFormat);
      } else if(navigateParams["date"]=='last') {
        fromDate = moment().subtract(1, 'M').startOf('month').format(this.dateFormat);
        toDate = moment(fromDate).endOf('month').format(this.dateFormat);
      } else if(navigateParams["date"]=='threeMonth') {
        fromDate = moment().subtract(3, 'M').startOf('month').format(this.dateFormat);
        toDate = moment().endOf('day').format(this.dateFormat);
      }

      const url = this.generateRouteURL(`batch-management/batches?status=close&fromDate=`+fromDate+`&toDate=`+toDate);
      window.open(decodeURIComponent(url), '_blank');
    }
  }

  generateRouteURL(urlString) {  
    return this.router.serializeUrl(
      this.router.createUrlTree([urlString])
    );
  }

  // Dashboard Settings
  openModalWidgetDS(content) {
    if (content) {
      this.modalService
        .open(content, { centered: true, size: "lg" })
        .result.then((result) => {
          this.modalWidget6 = "Modal closed" + result;
        })
        .catch((res) => { });
    }
  }

  getFilteredChartArray(arrayToFilter = [], argSplit) {
    const currentMonth = moment().month() + 1; // Adding 1 because months are zero-indexed
    const currentYear = moment().year();
    if (argSplit == 1) {
    // Filter the array to keep only the past or current month-year values
    const filteredArray = arrayToFilter.filter(item => {
      const parts = item.split(' - ');
      const itemMonth = moment().month(parts[0]).month() + 1; // Adding 1 because months are zero-indexed
      const itemYear = parseInt(parts[1]) + 2000;
      // Keep the item if it's from a past or current month-year
      return itemYear < currentYear || (itemYear === currentYear && itemMonth <= currentMonth);      
    });      
    return filteredArray;  
    } else {
    // Filter the array to keep only the past or current month-year values
      const filteredArray = arrayToFilter.filter(item => {
      // Keep the item if it's from a past or current month-year
      return item.perYear < currentYear || (item.perYear === currentYear && item.perMonth <= currentMonth);
    });        
    return filteredArray;
    }
  }
}
